var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5038 5.68892C9.65801 5.69326 9.81003 5.72651 9.95197 5.78695C10.0919 5.85409 10.2197 5.94401 10.3301 6.05305L14.9799 10.7028C15.1938 10.9247 15.3134 11.2209 15.3134 11.5291C15.3134 11.8373 15.1938 12.1335 14.9799 12.3554L10.3301 17.0052C10.1051 17.202 9.81676 17.3113 9.51781 17.3133C9.3691 17.313 9.22192 17.2832 9.08486 17.2255C8.9478 17.1678 8.82361 17.0834 8.71951 16.9772C8.4821 16.7707 8.33608 16.4787 8.31335 16.1649C8.31532 15.8659 8.42467 15.5776 8.62147 15.3526L12.5149 11.5011L8.6915 7.67767C8.58246 7.56723 8.49253 7.43944 8.4254 7.29952C8.36322 7.15323 8.32993 6.99629 8.32736 6.83735C8.32692 6.684 8.35543 6.53195 8.41139 6.38918C8.46608 6.24176 8.55196 6.10787 8.66314 5.99669C8.77433 5.8855 8.90821 5.79963 9.05563 5.74494C9.2003 5.69882 9.35224 5.67982 9.5038 5.68892Z",
    fill: "#242A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.7bc88ebb884c20fc0b2c29b7d48f8b03.svg";
export { ForwardRef as ReactComponent };